import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
} from "@mui/material";
import { formatHandlerCode } from "../../../utils/namesFormater";


interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: (params: { confirmedDate: Date; handlerCode: string }) => void;
  zipFilename: string;
  proposedDate?: string;
  proposedHandlerCode?: string; // ✅ חדש
}

export const CobolConfirmationDialog: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  zipFilename,
  proposedDate,
  proposedHandlerCode,
}) => {
  const [confirmedDate, setConfirmedDate] = useState<string>(proposedDate || "");
  const [handlerCode, setHandlerCode] = useState<string>(proposedHandlerCode || "520042177");

  // עדכון ברירת מחדל אם מגיעות הצעות חדשות מהשרת
  useEffect(() => {
    if (proposedHandlerCode) {
      setHandlerCode(proposedHandlerCode);
    }
    if (proposedDate) {
      setConfirmedDate(proposedDate);
    }
  }, [proposedHandlerCode, proposedDate]);

  const handleConfirm = () => {
    if (confirmedDate && handlerCode) {
      onConfirm({
        confirmedDate: new Date(confirmedDate),
        handlerCode,
      });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>אישור נתונים עבור קובץ {zipFilename}</DialogTitle>
      <DialogContent>
        {/* שדה תאריך כטקסט חופשי */}
        <TextField
          label="תאריך דיווח"
          value={confirmedDate}
          onChange={(e) => setConfirmedDate(e.target.value)}
          fullWidth
          margin="normal"
        />

        {/* Select עם שתי אפשרויות ל־Handler Code */}
        <TextField
          select
          label="בחר יצרן מטפל"
          value={handlerCode}
          onChange={(e) => setHandlerCode(e.target.value)}
          fullWidth
          margin="normal"
        >
          {["520042177", "520004078"].map((code) => (
            <MenuItem key={code} value={code}>
              {formatHandlerCode(code)}
            </MenuItem>
          ))}
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>ביטול</Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          אישור
        </Button>
      </DialogActions>
    </Dialog>
  );
};
